// Generated by script, please do not edit this file.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import * as React from 'react';
import { forwardRef } from 'react';
var PeopleBranch = function(props, ref) {
    return /*#__PURE__*/ React.createElement("svg", _object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        ref: ref
    }, props), /*#__PURE__*/ React.createElement("path", {
        d: "M12.5 5a1.5 1.5 0 1 1-1.401 2.036c-.739.136-1.247.678-1.752 1.687l-.536 1.136-.073.14h4.347A1.5 1.5 0 1 1 13.086 11l-3.193-.001q.096.267.175.612l.157.722.011.045c.257 1.028.704 1.519 1.856 1.607a1.5 1.5 0 1 1-.01 1.001c-1.667-.113-2.455-.923-2.816-2.365l-.055-.233-.079-.378c-.164-.787-.266-.985-.564-1.008L8.501 11h-2a.5.5 0 0 1 0-1h1c.054 0 .172-.124.354-.465l.092-.182.507-1.076C9.12 6.944 9.89 6.17 11.078 6.025A1.5 1.5 0 0 1 12.501 5zm1 9a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m1-4a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-2-4a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M7 0a3 3 0 1 1 0 6 3 3 0 0 1 0-6m0 1a2 2 0 1 0-.001 3.999A2 2 0 0 0 7 1M2 3a2 2 0 1 1 .001 3.999A2 2 0 0 1 2 3m0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M7 5a.5.5 0 0 1 0 1C5.641 6 4.113 7.345 4.006 8.834L4 9v3.5a.5.5 0 0 0 .41.492L4.5 13H8a.5.5 0 0 1 .09.992L8 14H4.5a1.5 1.5 0 0 1-1.493-1.356L3 12.5V9c0-2.128 2.059-4 4-4M2.474 7.342a.5.5 0 0 0-.632-.316C.681 7.413.064 8.365.005 9.774L0 10v2.5a.5.5 0 0 0 .992.09L1 12.5V10c0-1.133.38-1.766 1.158-2.026a.5.5 0 0 0 .316-.632"
    }));
};
var ForwardRef = /*#__PURE__*/ forwardRef(PeopleBranch);
export default ForwardRef;
